import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
} from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

import { FeatureGuardMode, GuardedFeature } from '@recruitee/feature-guard';
import { DialogRef, IconName } from '@recruitee/user-interface';

@Component({
  selector: 'rt-redactor-inserts-dropdown-item',
  templateUrl: 'redactor-inserts-dropdown-item.component.html',
  styleUrls: ['./redactor-inserts-dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedactorInsertsDropdownItemComponent {
  @Input() public iconName: IconName;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public link?: string;
  @Input() public linkNavigationExtras: NavigationExtras;
  @Input() public selected: boolean;
  @Input() public featureGuard: GuardedFeature;
  @Input() public badgeText?: string;

  @Output() public stepInside: EventEmitter<MouseEvent> = new EventEmitter();

  public featureGuardMode: typeof FeatureGuardMode = FeatureGuardMode;

  constructor(private router: Router, @Optional() private dialogRef: DialogRef) {}

  public goToPage(link: string): void {
    if (this.dialogRef) {
      this.dialogRef.afterClosed.subscribe(() => {
        this.router.navigate([link], this.linkNavigationExtras);
      });

      this.dialogRef.close();
    } else {
      this.router.navigate([link], this.linkNavigationExtras);
    }
  }
}
